import { render } from "./as-modal.vue?vue&type=template&id=54017410&scoped=true&ts=true"
import script from "./as-modal.vue?vue&type=script&lang=ts"
export * from "./as-modal.vue?vue&type=script&lang=ts"

import "./as-modal.vue?vue&type=style&index=0&id=54017410&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54017410"]])

export default __exports__